import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl(API_CONFIG.ENDPOINTS.ADMIN);

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

export const adminService = {
  // Lấy thống kê dashboard
  getDashboardStats: async () => {
    try {
      const response = await axios.get(`${API_URL}/dashboard/stats`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy thống kê'));
    }
  },

  // Lấy danh sách users
  getUsers: async (page = 1, limit = 10, search = '') => {
    try {
      const response = await axios.get(`${API_URL}/users?page=${page}&limit=${limit}&search=${search}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy danh sách users'));
    }
  },

  // Lấy chi tiết user
  getUserDetail: async (userId) => {
    try {
      const response = await axios.get(`${API_URL}/users/${userId}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy thông tin user'));
    }
  },

  // Điều chỉnh số dư user
  adjustBalance: async (userId, amount, action) => {
    try {
      const response = await axios.post(`${API_URL}/users/${userId}/adjust-balance`, { amount, action }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể điều chỉnh số dư'));
    }
  },

  // Gán VIP cho user
  setUserVip: async (userId, vip) => {
    try {
      const response = await axios.put(`${API_URL}/users/${userId}/vip`, { vip }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể cập nhật VIP user'));
    }
  },

  // Cộng hoặc trừ số dư user
  adjustUserBalance: async (userId, amount, action) => {
    try {
      const response = await axios.put(`${API_URL}/users/${userId}/balance`, {
        amount,
        action
      }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể điều chỉnh số dư'));
    }
  },

  // Mở khóa toàn bộ số dư đóng băng
  unlockUserBalance: async (userId) => {
    try {
      const response = await axios.put(`${API_URL}/users/${userId}/unlock-balance`, {}, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể mở khóa số dư'));
    }
  },

  // Đổi mật khẩu user
  changeUserPassword: async (userId, newPassword) => {
    try {
      const response = await axios.put(`${API_URL}/users/${userId}/password`, {
        new_password: newPassword
      }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể đổi mật khẩu'));
    }
  },

  // Khóa/Mở khóa user
  lockUser: async (userId, status) => {
    try {
      const response = await axios.put(`${API_URL}/users/${userId}/lock`, {
        status
      }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể thay đổi trạng thái user'));
    }
  },

  // Lấy cấu hình các cấp VIP
  getVipConfigs: async () => {
    try {
      const response = await axios.get(`${API_URL}/vip-config`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy cấu hình VIP'));
    }
  },

  // Cập nhật cấu hình một cấp VIP
  updateVipConfig: async (vipId, data) => {
    try {
      const response = await axios.put(`${API_URL}/vip-config/${vipId}`, data, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể cập nhật cấu hình VIP'));
    }
  },

  // 新手三日剧本
  getNewbiePlan: async () => {
    try {
      const response = await axios.get(`${API_URL}/newbie-plan`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy kịch bản người mới'));
    }
  },

  updateNewbiePlan: async (planId, data) => {
    try {
      const response = await axios.put(`${API_URL}/newbie-plan/${planId}`, data, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể cập nhật kịch bản người mới'));
    }
  },

  // 幸运订单人工审核
  getLuckyOrdersReview: async () => {
    try {
      const response = await axios.get(`${API_URL}/lucky-orders/review`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy danh sách đơn may mắn'));
    }
  },

  getPaymentConfig: async () => {
    try {
      const response = await axios.get(`${API_URL}/payment-config`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể tải cấu hình thanh toán'));
    }
  },

  savePaymentConfig: async (tronAddress) => {
    try {
      const response = await axios.put(`${API_URL}/payment-config`, { tronAddress }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lưu cấu hình thanh toán'));
    }
  },

  approveLuckyOrder: async (id) => {
    try {
      const response = await axios.post(`${API_URL}/lucky-orders/${id}/approve`, {}, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể duyệt đơn may mắn'));
    }
  },

  rejectLuckyOrder: async (id, reason) => {
    try {
      const response = await axios.post(`${API_URL}/lucky-orders/${id}/reject`, { reason }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể từ chối đơn may mắn'));
    }
  },

  // Lấy danh sách deposits
  getDeposits: async (status = 'all', limit = 50, page = 1) => {
    try {
      const response = await axios.get(`${API_URL}/deposits?status=${status}&limit=${limit}&page=${page}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy danh sách nạp tiền'));
    }
  },

  // Duyệt deposit
  approveDeposit: async (depositId, adminNote = '') => {
    try {
      const response = await axios.post(`${API_URL}/deposits/${depositId}/approve`, {
        admin_note: adminNote
      }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể duyệt yêu cầu'));
    }
  },

  // Từ chối deposit
  rejectDeposit: async (depositId, adminNote = '') => {
    try {
      const response = await axios.post(`${API_URL}/deposits/${depositId}/reject`, {
        admin_note: adminNote
      }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể từ chối yêu cầu'));
    }
  },

  // Lấy danh sách withdraws
  getWithdraws: async (status = 'all', limit = 50, page = 1) => {
    try {
      const response = await axios.get(`${API_URL}/withdraws?status=${status}&limit=${limit}&page=${page}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy danh sách rút tiền'));
    }
  },

  // Duyệt withdraw
  approveWithdraw: async (withdrawId, adminNote = '') => {
    try {
      const response = await axios.post(`${API_URL}/withdraws/${withdrawId}/approve`, {
        admin_note: adminNote
      }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể duyệt yêu cầu'));
    }
  },

  // Từ chối withdraw
  rejectWithdraw: async (withdrawId, adminNote = '') => {
    try {
      const response = await axios.post(`${API_URL}/withdraws/${withdrawId}/reject`, {
        admin_note: adminNote
      }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể từ chối yêu cầu'));
    }
  },

  // 实名认证：列表
  getKycs: async (status = 'all', limit = 50, page = 1) => {
    try {
      const response = await axios.get(`${API_URL}/kycs?status=${status}&limit=${limit}&page=${page}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy danh sách xác minh'));
    }
  },

  // 实名认证：通过
  approveKyc: async (kycId) => {
    try {
      const response = await axios.post(`${API_URL}/kycs/${kycId}/approve`, {}, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể duyệt xác minh'));
    }
  },

  // 实名认证：驳回
  rejectKyc: async (kycId, rejectReason = '') => {
    try {
      const response = await axios.post(`${API_URL}/kycs/${kycId}/reject`, { reject_reason: rejectReason }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể từ chối xác minh'));
    }
  },

  // 社交账号绑定：列表
  getSocials: async (status = 'all', limit = 50, page = 1) => {
    try {
      const response = await axios.get(`${API_URL}/socials?status=${status}&limit=${limit}&page=${page}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy danh sách liên kết'));
    }
  },

  // 社交账号绑定：通过
  approveSocial: async (socialId) => {
    try {
      const response = await axios.post(`${API_URL}/socials/${socialId}/approve`, {}, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể duyệt liên kết'));
    }
  },

  // 社交账号绑定：驳回
  rejectSocial: async (socialId, rejectReason = '') => {
    try {
      const response = await axios.post(`${API_URL}/socials/${socialId}/reject`, { reject_reason: rejectReason }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể từ chối liên kết'));
    }
  },

  // Lấy lịch sử đơn hàng
  getOrders: async (search = '', limit = 50, page = 1) => {
    try {
      const response = await axios.get(`${API_URL}/orders?search=${search}&limit=${limit}&page=${page}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy lịch sử đơn hàng'));
    }
  },

  // Tạo tài khoản user mới
  createUser: async (userData) => {
    try {
      const response = await axios.post(`${API_URL}/users/create`, userData, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể tạo tài khoản'));
    }
  },

  // Lấy lịch sử chat với user
  getChatHistory: async (userId, limit = 50, offset = 0) => {
    try {
      const response = await axios.get(`${API_URL}/chat/history/${userId}?limit=${limit}&offset=${offset}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy lịch sử chat'));
    }
  },

  // Xóa lịch sử chat với user
  deleteChatHistory: async (userId) => {
    try {
      const response = await axios.delete(`${API_URL}/chat/history/${userId}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể xóa lịch sử chat'));
    }
  },

  // Đổi mật khẩu admin (không cần mật khẩu cũ)
  changeAdminPassword: async (newPassword) => {
    try {
      const response = await axios.put(`${API_URL}/change-password`, { newPassword }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể đổi mật khẩu'));
    }
  },

  // Xóa toàn bộ lịch sử quay đơn của TẤT CẢ user
  deleteAllOrderHistory: async () => {
    try {
      const response = await axios.delete(`${API_URL}/order-history/all`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể xóa lịch sử quay đơn'));
    }
  },

  // Xóa toàn bộ lịch sử quay đơn của user
  deleteUserOrderHistory: async (userId) => {
    try {
      const response = await axios.delete(`${API_URL}/users/${userId}/order-history`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể xóa lịch sử quay đơn'));
    }
  },

  // Xóa user hoàn toàn
  deleteUser: async (userId) => {
    try {
      const response = await axios.delete(`${API_URL}/users/${userId}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể xóa user'));
    }
  },

  // Tìm kiếm user để làm người giới thiệu
  searchReferrer: async (search = '', excludeId = '') => {
    try {
      const response = await axios.get(`${API_URL}/users/search-referrer?search=${search}&excludeId=${excludeId}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể tìm kiếm user'));
    }
  },

  // Set người giới thiệu cho user
  setReferrer: async (userId, referrerId) => {
    try {
      const response = await axios.post(`${API_URL}/users/${userId}/set-referrer`, { referrerId }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể set người giới thiệu'));
    }
  },

  // Xóa người giới thiệu
  removeReferrer: async (userId) => {
    try {
      const response = await axios.delete(`${API_URL}/users/${userId}/remove-referrer`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể xóa người giới thiệu'));
    }
  },

  // Tạo mã giới thiệu cho user
  generateReferralCode: async (userId) => {
    try {
      const response = await axios.post(`${API_URL}/users/${userId}/generate-referral-code`, {}, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể tạo mã giới thiệu'));
    }
  },

  // Get bonus orders
  getBonusOrders: async (userId) => {
    try {
      const response = await axios.get(`${API_URL}/users/${userId}/bonus-orders`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy bonus orders'));
    }
  },

  // Set bonus order (with file upload)
  setBonusOrder: async (userId, position, imageFile, productPrice) => {
    try {
      const formData = new FormData();
      formData.append('position', position);
      formData.append('productPrice', productPrice);
      formData.append('image', imageFile);

      const response = await axios.post(`${API_URL}/users/${userId}/set-bonus-order`, formData, {
        ...getAuthHeader(),
        headers: {
          ...getAuthHeader().headers,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể set bonus order'));
    }
  },

  // Delete bonus order
  deleteBonusOrder: async (userId, position) => {
    try {
      const response = await axios.delete(`${API_URL}/users/${userId}/delete-bonus-order`, {
        ...getAuthHeader(),
        data: { position }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể xóa bonus order'));
    }
  }
};
